import styled from 'styled-components';

export const Lista = styled.ul`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 12px;
  margin: 0 0 16px 0;
  padding: 0;
  list-style: none;
`;

export const Card = styled.li`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: 10px;
  background-color: ${({ theme }) => theme.cardBackground};
  box-shadow: 0 1px 2px ${({ theme }) => theme.shadowColor};
`;

export const Icone = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  border-radius: 8px;
  font-size: 15px;
  color: ${({ theme }) => theme.primaryColor};
  background-color: ${({ theme }) => theme.lightColor};
`;

export const Texto = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const Valor = styled.strong`
  font-size: 20px;
  line-height: 1.1;
  color: ${({ theme }) => theme.textColor};
`;

export const Rotulo = styled.span`
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: ${({ theme }) => theme.darkGray};
`;
